/**
 * Dicionario de 4096 palavras para o codec unicode-words.
 *
 * 2048 em portugues + 2048 em ingles, das listas BIP-39 (bitcoin/bips,
 * BSD-2-Clause). As duas listas nao tem uma unica palavra em comum, o que
 * dispensou completar com uma terceira lingua.
 *
 * Criterios, verificados por teste:
 *   - exatamente 4096 palavras = 12 bits cada
 *   - sem repeticao: a decodificacao e uma busca exata
 *   - somente a-z minusculo: sobrevive a autocorrecao e a normalizacao
 *
 * A mistura de portugues e ingles e proposital: uma frase so em portugues
 * com palavras aleatorias soa estranha; misturada, passa por nome de
 * usuario, senha gerada ou spam — coisas que ninguem le duas vezes.
 *
 * ARQUIVO GERADO — nao editar a mao.
 */

export const WORD_ALPHABET: readonly string[] = [
  'abacate',
  'abaixo',
  'abalar',
  'abater',
  'abduzir',
  'abelha',
  'aberto',
  'abismo',
  'abotoar',
  'abranger',
  'abreviar',
  'abrigar',
  'abrupto',
  'absinto',
  'absoluto',
  'absurdo',
  'abutre',
  'acabado',
  'acalmar',
  'acampar',
  'acanhar',
  'acaso',
  'aceitar',
  'acelerar',
  'acenar',
  'acervo',
  'acessar',
  'acetona',
  'achatar',
  'acidez',
  'acima',
  'acionado',
  'acirrar',
  'aclamar',
  'aclive',
  'acolhida',
  'acomodar',
  'acoplar',
  'acordar',
  'acumular',
  'acusador',
  'adaptar',
  'adega',
  'adentro',
  'adepto',
  'adequar',
  'aderente',
  'adesivo',
  'adeus',
  'adiante',
  'aditivo',
  'adjetivo',
  'adjunto',
  'admirar',
  'adorar',
  'adquirir',
  'adubo',
  'adverso',
  'advogado',
  'aeronave',
  'afastar',
  'aferir',
  'afetivo',
  'afinador',
  'afivelar',
  'aflito',
  'afluente',
  'afrontar',
  'agachar',
  'agarrar',
  'agasalho',
  'agenciar',
  'agilizar',
  'agiota',
  'agitado',
  'agora',
  'agradar',
  'agreste',
  'agrupar',
  'aguardar',
  'agulha',
  'ajoelhar',
  'ajudar',
  'ajustar',
  'alameda',
  'alarme',
  'alastrar',
  'alavanca',
  'albergue',
  'albino',
  'alcatra',
  'aldeia',
  'alecrim',
  'alegria',
  'alertar',
  'alface',
  'alfinete',
  'algum',
  'alheio',
  'aliar',
  'alicate',
  'alienar',
  'alinhar',
  'aliviar',
  'almofada',
  'alocar',
  'alpiste',
  'alterar',
  'altitude',
  'alucinar',
  'alugar',
  'aluno',
  'alusivo',
  'alvo',
  'amaciar',
  'amador',
  'amarelo',
  'amassar',
  'ambas',
  'ambiente',
  'ameixa',
  'amenizar',
  'amido',
  'amistoso',
  'amizade',
  'amolador',
  'amontoar',
  'amoroso',
  'amostra',
  'amparar',
  'ampliar',
  'ampola',
  'anagrama',
  'analisar',
  'anarquia',
  'anatomia',
  'andaime',
  'anel',
  'anexo',
  'angular',
  'animar',
  'anjo',
  'anomalia',
  'anotado',
  'ansioso',
  'anterior',
  'anuidade',
  'anunciar',
  'anzol',
  'apagador',
  'apalpar',
  'apanhado',
  'apego',
  'apelido',
  'apertada',
  'apesar',
  'apetite',
  'apito',
  'aplauso',
  'aplicada',
  'apoio',
  'apontar',
  'aposta',
  'aprendiz',
  'aprovar',
  'aquecer',
  'arame',
  'aranha',
  'arara',
  'arcada',
  'ardente',
  'areia',
  'arejar',
  'arenito',
  'aresta',
  'argiloso',
  'argola',
  'arma',
  'arquivo',
  'arraial',
  'arrebate',
  'arriscar',
  'arroba',
  'arrumar',
  'arsenal',
  'arterial',
  'artigo',
  'arvoredo',
  'asfaltar',
  'asilado',
  'aspirar',
  'assador',
  'assinar',
  'assoalho',
  'assunto',
  'astral',
  'atacado',
  'atadura',
  'atalho',
  'atarefar',
  'atear',
  'atender',
  'aterro',
  'ateu',
  'atingir',
  'atirador',
  'ativo',
  'atoleiro',
  'atracar',
  'atrevido',
  'atriz',
  'atual',
  'atum',
  'auditor',
  'aumentar',
  'aura',
  'aurora',
  'autismo',
  'autoria',
  'autuar',
  'avaliar',
  'avante',
  'avaria',
  'avental',
  'avesso',
  'aviador',
  'avisar',
  'avulso',
  'axila',
  'azarar',
  'azedo',
  'azeite',
  'azulejo',
  'babar',
  'babosa',
  'bacalhau',
  'bacharel',
  'bacia',
  'bagagem',
  'baiano',
  'bailar',
  'baioneta',
  'bairro',
  'baixista',
  'bajular',
  'baleia',
  'baliza',
  'balsa',
  'banal',
  'bandeira',
  'banho',
  'banir',
  'banquete',
  'barato',
  'barbado',
  'baronesa',
  'barraca',
  'barulho',
  'baseado',
  'bastante',
  'batata',
  'batedor',
  'batida',
  'batom',
  'batucar',
  'baunilha',
  'beber',
  'beijo',
  'beirada',
  'beisebol',
  'beldade',
  'beleza',
  'belga',
  'beliscar',
  'bendito',
  'bengala',
  'benzer',
  'berimbau',
  'berlinda',
  'berro',
  'besouro',
  'bexiga',
  'bezerro',
  'bico',
  'bicudo',
  'bienal',
  'bifocal',
  'bifurcar',
  'bigorna',
  'bilhete',
  'bimestre',
  'bimotor',
  'biologia',
  'biombo',
  'biosfera',
  'bipolar',
  'birrento',
  'biscoito',
  'bisneto',
  'bispo',
  'bissexto',
  'bitola',
  'bizarro',
  'blindado',
  'bloco',
  'bloquear',
  'boato',
  'bobagem',
  'bocado',
  'bocejo',
  'bochecha',
  'boicotar',
  'bolada',
  'boletim',
  'bolha',
  'bolo',
  'bombeiro',
  'bonde',
  'boneco',
  'bonita',
  'borbulha',
  'borda',
  'boreal',
  'borracha',
  'bovino',
  'boxeador',
  'branco',
  'brasa',
  'braveza',
  'breu',
  'briga',
  'brilho',
  'brincar',
  'broa',
  'brochura',
  'bronzear',
  'broto',
  'bruxo',
  'bucha',
  'budismo',
  'bufar',
  'bule',
  'buraco',
  'busca',
  'busto',
  'buzina',
  'cabana',
  'cabelo',
  'cabide',
  'cabo',
  'cabrito',
  'cacau',
  'cacetada',
  'cachorro',
  'cacique',
  'cadastro',
  'cadeado',
  'cafezal',
  'caiaque',
  'caipira',
  'caixote',
  'cajado',
  'caju',
  'calafrio',
  'calcular',
  'caldeira',
  'calibrar',
  'calmante',
  'calota',
  'camada',
  'cambista',
  'camisa',
  'camomila',
  'campanha',
  'camuflar',
  'canavial',
  'cancelar',
  'caneta',
  'canguru',
  'canhoto',
  'canivete',
  'canoa',
  'cansado',
  'cantar',
  'canudo',
  'capacho',
  'capela',
  'capinar',
  'capotar',
  'capricho',
  'captador',
  'capuz',
  'caracol',
  'carbono',
  'cardeal',
  'careca',
  'carimbar',
  'carneiro',
  'carpete',
  'carreira',
  'cartaz',
  'carvalho',
  'casaco',
  'casca',
  'casebre',
  'castelo',
  'casulo',
  'catarata',
  'cativar',
  'caule',
  'causador',
  'cautelar',
  'cavalo',
  'caverna',
  'cebola',
  'cedilha',
  'cegonha',
  'celebrar',
  'celular',
  'cenoura',
  'censo',
  'centeio',
  'cercar',
  'cerrado',
  'certeiro',
  'cerveja',
  'cetim',
  'cevada',
  'chacota',
  'chaleira',
  'chamado',
  'chapada',
  'charme',
  'chatice',
  'chave',
  'chefe',
  'chegada',
  'cheiro',
  'cheque',
  'chicote',
  'chifre',
  'chinelo',
  'chocalho',
  'chover',
  'chumbo',
  'chutar',
  'chuva',
  'cicatriz',
  'ciclone',
  'cidade',
  'cidreira',
  'ciente',
  'cigana',
  'cimento',
  'cinto',
  'cinza',
  'ciranda',
  'circuito',
  'cirurgia',
  'citar',
  'clareza',
  'clero',
  'clicar',
  'clone',
  'clube',
  'coado',
  'coagir',
  'cobaia',
  'cobertor',
  'cobrar',
  'cocada',
  'coelho',
  'coentro',
  'coeso',
  'cogumelo',
  'coibir',
  'coifa',
  'coiote',
  'colar',
  'coleira',
  'colher',
  'colidir',
  'colmeia',
  'colono',
  'coluna',
  'comando',
  'combinar',
  'comentar',
  'comitiva',
  'comover',
  'complexo',
  'comum',
  'concha',
  'condor',
  'conectar',
  'confuso',
  'congelar',
  'conhecer',
  'conjugar',
  'consumir',
  'contrato',
  'convite',
  'cooperar',
  'copeiro',
  'copiador',
  'copo',
  'coquetel',
  'coragem',
  'cordial',
  'corneta',
  'coronha',
  'corporal',
  'correio',
  'cortejo',
  'coruja',
  'corvo',
  'cosseno',
  'costela',
  'cotonete',
  'couro',
  'couve',
  'covil',
  'cozinha',
  'cratera',
  'cravo',
  'creche',
  'credor',
  'creme',
  'crer',
  'crespo',
  'criada',
  'criminal',
  'crioulo',
  'crise',
  'criticar',
  'crosta',
  'crua',
  'cruzeiro',
  'cubano',
  'cueca',
  'cuidado',
  'cujo',
  'culatra',
  'culminar',
  'culpar',
  'cultura',
  'cumprir',
  'cunhado',
  'cupido',
  'curativo',
  'curral',
  'cursar',
  'curto',
  'cuspir',
  'custear',
  'cutelo',
  'damasco',
  'datar',
  'debater',
  'debitar',
  'deboche',
  'debulhar',
  'decalque',
  'decimal',
  'declive',
  'decote',
  'decretar',
  'dedal',
  'dedicado',
  'deduzir',
  'defesa',
  'defumar',
  'degelo',
  'degrau',
  'degustar',
  'deitado',
  'deixar',
  'delator',
  'delegado',
  'delinear',
  'delonga',
  'demanda',
  'demitir',
  'demolido',
  'dentista',
  'depenado',
  'depilar',
  'depois',
  'depressa',
  'depurar',
  'deriva',
  'derramar',
  'desafio',
  'desbotar',
  'descanso',
  'desenho',
  'desfiado',
  'desgaste',
  'desigual',
  'deslize',
  'desmamar',
  'desova',
  'despesa',
  'destaque',
  'desviar',
  'detalhar',
  'detentor',
  'detonar',
  'detrito',
  'deusa',
  'dever',
  'devido',
  'devotado',
  'dezena',
  'diagrama',
  'dialeto',
  'didata',
  'difuso',
  'digitar',
  'dilatado',
  'diluente',
  'diminuir',
  'dinastia',
  'dinheiro',
  'diocese',
  'direto',
  'discreta',
  'disfarce',
  'disparo',
  'disquete',
  'dissipar',
  'distante',
  'ditador',
  'diurno',
  'diverso',
  'divisor',
  'divulgar',
  'dizer',
  'dobrador',
  'dolorido',
  'domador',
  'dominado',
  'donativo',
  'donzela',
  'dormente',
  'dorsal',
  'dosagem',
  'dourado',
  'doutor',
  'drenagem',
  'drible',
  'drogaria',
  'duelar',
  'duende',
  'dueto',
  'duplo',
  'duquesa',
  'durante',
  'duvidoso',
  'eclodir',
  'ecoar',
  'ecologia',
  'edificar',
  'edital',
  'educado',
  'efeito',
  'efetivar',
  'ejetar',
  'elaborar',
  'eleger',
  'eleitor',
  'elenco',
  'elevador',
  'eliminar',
  'elogiar',
  'embargo',
  'embolado',
  'embrulho',
  'embutido',
  'emenda',
  'emergir',
  'emissor',
  'empatia',
  'empenho',
  'empinado',
  'empolgar',
  'emprego',
  'empurrar',
  'emulador',
  'encaixe',
  'encenado',
  'enchente',
  'encontro',
  'endeusar',
  'endossar',
  'enfaixar',
  'enfeite',
  'enfim',
  'engajado',
  'engenho',
  'englobar',
  'engomado',
  'engraxar',
  'enguia',
  'enjoar',
  'enlatar',
  'enquanto',
  'enraizar',
  'enrolado',
  'enrugar',
  'ensaio',
  'enseada',
  'ensino',
  'ensopado',
  'entanto',
  'enteado',
  'entidade',
  'entortar',
  'entrada',
  'entulho',
  'envergar',
  'enviado',
  'envolver',
  'enxame',
  'enxerto',
  'enxofre',
  'enxuto',
  'epiderme',
  'equipar',
  'ereto',
  'erguido',
  'errata',
  'erva',
  'ervilha',
  'esbanjar',
  'esbelto',
  'escama',
  'escola',
  'escrita',
  'escuta',
  'esfinge',
  'esfolar',
  'esfregar',
  'esfumado',
  'esgrima',
  'esmalte',
  'espanto',
  'espelho',
  'espiga',
  'esponja',
  'espreita',
  'espumar',
  'esquerda',
  'estaca',
  'esteira',
  'esticar',
  'estofado',
  'estrela',
  'estudo',
  'esvaziar',
  'etanol',
  'etiqueta',
  'euforia',
  'europeu',
  'evacuar',
  'evaporar',
  'evasivo',
  'eventual',
  'evidente',
  'evoluir',
  'exagero',
  'exalar',
  'examinar',
  'exato',
  'exausto',
  'excesso',
  'excitar',
  'exclamar',
  'executar',
  'exemplo',
  'exibir',
  'exigente',
  'exonerar',
  'expandir',
  'expelir',
  'expirar',
  'explanar',
  'exposto',
  'expresso',
  'expulsar',
  'externo',
  'extinto',
  'extrato',
  'fabricar',
  'fabuloso',
  'faceta',
  'facial',
  'fada',
  'fadiga',
  'faixa',
  'falar',
  'falta',
  'familiar',
  'fandango',
  'fanfarra',
  'fantoche',
  'fardado',
  'farelo',
  'farinha',
  'farofa',
  'farpa',
  'fartura',
  'fatia',
  'fator',
  'favorita',
  'faxina',
  'fazenda',
  'fechado',
  'feijoada',
  'feirante',
  'felino',
  'feminino',
  'fenda',
  'feno',
  'fera',
  'feriado',
  'ferrugem',
  'ferver',
  'festejar',
  'fetal',
  'feudal',
  'fiapo',
  'fibrose',
  'ficar',
  'ficheiro',
  'figurado',
  'fileira',
  'filho',
  'filme',
  'filtrar',
  'firmeza',
  'fisgada',
  'fissura',
  'fita',
  'fivela',
  'fixador',
  'fixo',
  'flacidez',
  'flamingo',
  'flanela',
  'flechada',
  'flora',
  'flutuar',
  'fluxo',
  'focal',
  'focinho',
  'fofocar',
  'fogo',
  'foguete',
  'foice',
  'folgado',
  'folheto',
  'forjar',
  'formiga',
  'forno',
  'forte',
  'fosco',
  'fossa',
  'fragata',
  'fralda',
  'frango',
  'frasco',
  'fraterno',
  'freira',
  'frente',
  'fretar',
  'frieza',
  'friso',
  'fritura',
  'fronha',
  'frustrar',
  'fruteira',
  'fugir',
  'fulano',
  'fuligem',
  'fundar',
  'fungo',
  'funil',
  'furador',
  'furioso',
  'futebol',
  'gabarito',
  'gabinete',
  'gado',
  'gaiato',
  'gaiola',
  'gaivota',
  'galega',
  'galho',
  'galinha',
  'galocha',
  'ganhar',
  'garagem',
  'garfo',
  'gargalo',
  'garimpo',
  'garoupa',
  'garrafa',
  'gasoduto',
  'gasto',
  'gata',
  'gatilho',
  'gaveta',
  'gazela',
  'gelado',
  'geleia',
  'gelo',
  'gemada',
  'gemer',
  'gemido',
  'generoso',
  'gengiva',
  'genial',
  'genoma',
  'genro',
  'geologia',
  'gerador',
  'germinar',
  'gesso',
  'gestor',
  'ginasta',
  'gincana',
  'gingado',
  'girafa',
  'girino',
  'glacial',
  'glicose',
  'global',
  'glorioso',
  'goela',
  'goiaba',
  'golfe',
  'golpear',
  'gordura',
  'gorjeta',
  'gorro',
  'gostoso',
  'goteira',
  'governar',
  'gracejo',
  'gradual',
  'grafite',
  'gralha',
  'grampo',
  'granada',
  'gratuito',
  'graveto',
  'graxa',
  'grego',
  'grelhar',
  'greve',
  'grilo',
  'grisalho',
  'gritaria',
  'grosso',
  'grotesco',
  'grudado',
  'grunhido',
  'gruta',
  'guache',
  'guarani',
  'guaxinim',
  'guerrear',
  'guiar',
  'guincho',
  'guisado',
  'gula',
  'guloso',
  'guru',
  'habitar',
  'harmonia',
  'haste',
  'haver',
  'hectare',
  'herdar',
  'heresia',
  'hesitar',
  'hiato',
  'hibernar',
  'hidratar',
  'hiena',
  'hino',
  'hipismo',
  'hipnose',
  'hipoteca',
  'hoje',
  'holofote',
  'homem',
  'honesto',
  'honrado',
  'hormonal',
  'hospedar',
  'humorado',
  'iate',
  'ideia',
  'idoso',
  'ignorado',
  'igreja',
  'iguana',
  'ileso',
  'ilha',
  'iludido',
  'iluminar',
  'ilustrar',
  'imagem',
  'imediato',
  'imenso',
  'imersivo',
  'iminente',
  'imitador',
  'imortal',
  'impacto',
  'impedir',
  'implante',
  'impor',
  'imprensa',
  'impune',
  'imunizar',
  'inalador',
  'inapto',
  'inativo',
  'incenso',
  'inchar',
  'incidir',
  'incluir',
  'incolor',
  'indeciso',
  'indireto',
  'indutor',
  'ineficaz',
  'inerente',
  'infantil',
  'infestar',
  'infinito',
  'inflamar',
  'informal',
  'infrator',
  'ingerir',
  'inibido',
  'inicial',
  'inimigo',
  'injetar',
  'inocente',
  'inodoro',
  'inovador',
  'inox',
  'inquieto',
  'inscrito',
  'inseto',
  'insistir',
  'inspetor',
  'instalar',
  'insulto',
  'intacto',
  'integral',
  'intimar',
  'intocado',
  'intriga',
  'invasor',
  'inverno',
  'invicto',
  'invocar',
  'iogurte',
  'iraniano',
  'ironizar',
  'irreal',
  'irritado',
  'isca',
  'isento',
  'isolado',
  'isqueiro',
  'italiano',
  'janeiro',
  'jangada',
  'janta',
  'jararaca',
  'jardim',
  'jarro',
  'jasmim',
  'jato',
  'javali',
  'jazida',
  'jejum',
  'joaninha',
  'joelhada',
  'jogador',
  'joia',
  'jornal',
  'jorrar',
  'jovem',
  'juba',
  'judeu',
  'judoca',
  'juiz',
  'julgador',
  'julho',
  'jurado',
  'jurista',
  'juro',
  'justa',
  'labareda',
  'laboral',
  'lacre',
  'lactante',
  'ladrilho',
  'lagarta',
  'lagoa',
  'laje',
  'lamber',
  'lamentar',
  'laminar',
  'lampejo',
  'lanche',
  'lapidar',
  'lapso',
  'laranja',
  'lareira',
  'largura',
  'lasanha',
  'lastro',
  'lateral',
  'latido',
  'lavanda',
  'lavoura',
  'lavrador',
  'laxante',
  'lazer',
  'lealdade',
  'lebre',
  'legado',
  'legendar',
  'legista',
  'leigo',
  'leiloar',
  'leitura',
  'lembrete',
  'leme',
  'lenhador',
  'lentilha',
  'leoa',
  'lesma',
  'leste',
  'letivo',
  'letreiro',
  'levar',
  'leveza',
  'levitar',
  'liberal',
  'libido',
  'liderar',
  'ligar',
  'ligeiro',
  'limitar',
  'limoeiro',
  'limpador',
  'linda',
  'linear',
  'linhagem',
  'liquidez',
  'listagem',
  'lisura',
  'litoral',
  'livro',
  'lixa',
  'lixeira',
  'locador',
  'locutor',
  'lojista',
  'lombo',
  'lona',
  'longe',
  'lontra',
  'lorde',
  'lotado',
  'loteria',
  'loucura',
  'lousa',
  'louvar',
  'luar',
  'lucidez',
  'lucro',
  'luneta',
  'lustre',
  'lutador',
  'luva',
  'macaco',
  'macete',
  'machado',
  'macio',
  'madeira',
  'madrinha',
  'magnata',
  'magreza',
  'maior',
  'mais',
  'malandro',
  'malha',
  'malote',
  'maluco',
  'mamilo',
  'mamoeiro',
  'mamute',
  'manada',
  'mancha',
  'mandato',
  'manequim',
  'manhoso',
  'manivela',
  'manobrar',
  'mansa',
  'manter',
  'manusear',
  'mapeado',
  'maquinar',
  'marcador',
  'maresia',
  'marfim',
  'margem',
  'marinho',
  'marmita',
  'maroto',
  'marquise',
  'marreco',
  'martelo',
  'marujo',
  'mascote',
  'masmorra',
  'massagem',
  'mastigar',
  'matagal',
  'materno',
  'matinal',
  'matutar',
  'maxilar',
  'medalha',
  'medida',
  'medusa',
  'megafone',
  'meiga',
  'melancia',
  'melhor',
  'membro',
  'memorial',
  'menino',
  'menos',
  'mensagem',
  'mental',
  'merecer',
  'mergulho',
  'mesada',
  'mesclar',
  'mesmo',
  'mesquita',
  'mestre',
  'metade',
  'meteoro',
  'metragem',
  'mexer',
  'mexicano',
  'micro',
  'migalha',
  'migrar',
  'milagre',
  'milenar',
  'milhar',
  'mimado',
  'minerar',
  'minhoca',
  'ministro',
  'minoria',
  'miolo',
  'mirante',
  'mirtilo',
  'misturar',
  'mocidade',
  'moderno',
  'modular',
  'moeda',
  'moer',
  'moinho',
  'moita',
  'moldura',
  'moleza',
  'molho',
  'molinete',
  'molusco',
  'montanha',
  'moqueca',
  'morango',
  'morcego',
  'mordomo',
  'morena',
  'mosaico',
  'mosquete',
  'mostarda',
  'motel',
  'motim',
  'moto',
  'motriz',
  'muda',
  'muito',
  'mulata',
  'mulher',
  'multar',
  'mundial',
  'munido',
  'muralha',
  'murcho',
  'muscular',
  'museu',
  'musical',
  'nacional',
  'nadador',
  'naja',
  'namoro',
  'narina',
  'narrado',
  'nascer',
  'nativa',
  'natureza',
  'navalha',
  'navegar',
  'navio',
  'neblina',
  'nebuloso',
  'negativa',
  'negociar',
  'negrito',
  'nervoso',
  'neta',
  'neural',
  'nevasca',
  'nevoeiro',
  'ninar',
  'ninho',
  'nitidez',
  'nivelar',
  'nobreza',
  'noite',
  'noiva',
  'nomear',
  'nominal',
  'nordeste',
  'nortear',
  'notar',
  'noticiar',
  'noturno',
  'novelo',
  'novilho',
  'novo',
  'nublado',
  'nudez',
  'numeral',
  'nupcial',
  'nutrir',
  'nuvem',
  'obcecado',
  'obedecer',
  'objetivo',
  'obrigado',
  'obscuro',
  'obstetra',
  'obter',
  'obturar',
  'ocidente',
  'ocioso',
  'ocorrer',
  'oculista',
  'ocupado',
  'ofegante',
  'ofensiva',
  'oferenda',
  'oficina',
  'ofuscado',
  'ogiva',
  'olaria',
  'oleoso',
  'olhar',
  'oliveira',
  'ombro',
  'omelete',
  'omisso',
  'omitir',
  'ondulado',
  'oneroso',
  'ontem',
  'opcional',
  'operador',
  'oponente',
  'oportuno',
  'oposto',
  'orar',
  'orbitar',
  'ordem',
  'ordinal',
  'orfanato',
  'orgasmo',
  'orgulho',
  'oriental',
  'origem',
  'oriundo',
  'orla',
  'ortodoxo',
  'orvalho',
  'oscilar',
  'ossada',
  'osso',
  'ostentar',
  'otimismo',
  'ousadia',
  'outono',
  'outubro',
  'ouvido',
  'ovelha',
  'ovular',
  'oxidar',
  'oxigenar',
  'pacato',
  'paciente',
  'pacote',
  'pactuar',
  'padaria',
  'padrinho',
  'pagar',
  'pagode',
  'painel',
  'pairar',
  'paisagem',
  'palavra',
  'palestra',
  'palheta',
  'palito',
  'palmada',
  'palpitar',
  'pancada',
  'panela',
  'panfleto',
  'panqueca',
  'pantanal',
  'papagaio',
  'papelada',
  'papiro',
  'parafina',
  'parcial',
  'pardal',
  'parede',
  'partida',
  'pasmo',
  'passado',
  'pastel',
  'patamar',
  'patente',
  'patinar',
  'patrono',
  'paulada',
  'pausar',
  'peculiar',
  'pedalar',
  'pedestre',
  'pediatra',
  'pedra',
  'pegada',
  'peitoral',
  'peixe',
  'pele',
  'pelicano',
  'penca',
  'pendurar',
  'peneira',
  'penhasco',
  'pensador',
  'pente',
  'perceber',
  'perfeito',
  'pergunta',
  'perito',
  'permitir',
  'perna',
  'perplexo',
  'persiana',
  'pertence',
  'peruca',
  'pescado',
  'pesquisa',
  'pessoa',
  'petiscar',
  'piada',
  'picado',
  'piedade',
  'pigmento',
  'pilastra',
  'pilhado',
  'pilotar',
  'pimenta',
  'pincel',
  'pinguim',
  'pinha',
  'pinote',
  'pintar',
  'pioneiro',
  'pipoca',
  'piquete',
  'piranha',
  'pires',
  'pirueta',
  'piscar',
  'pistola',
  'pitanga',
  'pivete',
  'planta',
  'plaqueta',
  'platina',
  'plebeu',
  'plumagem',
  'pluvial',
  'pneu',
  'poda',
  'poeira',
  'poetisa',
  'polegada',
  'policiar',
  'poluente',
  'polvilho',
  'pomar',
  'pomba',
  'ponderar',
  'pontaria',
  'populoso',
  'porta',
  'possuir',
  'postal',
  'pote',
  'poupar',
  'pouso',
  'povoar',
  'praia',
  'prancha',
  'prato',
  'praxe',
  'prece',
  'predador',
  'prefeito',
  'premiar',
  'prensar',
  'preparar',
  'presilha',
  'pretexto',
  'prevenir',
  'prezar',
  'primata',
  'princesa',
  'prisma',
  'privado',
  'processo',
  'produto',
  'profeta',
  'proibido',
  'projeto',
  'prometer',
  'propagar',
  'prosa',
  'protetor',
  'provador',
  'publicar',
  'pudim',
  'pular',
  'pulmonar',
  'pulseira',
  'punhal',
  'punir',
  'pupilo',
  'pureza',
  'puxador',
  'quadra',
  'quantia',
  'quarto',
  'quase',
  'quebrar',
  'queda',
  'queijo',
  'quente',
  'querido',
  'quimono',
  'quina',
  'quiosque',
  'rabanada',
  'rabisco',
  'rachar',
  'racionar',
  'radial',
  'raiar',
  'rainha',
  'raio',
  'raiva',
  'rajada',
  'ralado',
  'ramal',
  'ranger',
  'ranhura',
  'rapadura',
  'rapel',
  'rapidez',
  'raposa',
  'raquete',
  'raridade',
  'rasante',
  'rascunho',
  'rasgar',
  'raspador',
  'rasteira',
  'rasurar',
  'ratazana',
  'ratoeira',
  'realeza',
  'reanimar',
  'reaver',
  'rebaixar',
  'rebelde',
  'rebolar',
  'recado',
  'recente',
  'recheio',
  'recibo',
  'recordar',
  'recrutar',
  'recuar',
  'rede',
  'redimir',
  'redonda',
  'reduzida',
  'reenvio',
  'refinar',
  'refletir',
  'refogar',
  'refresco',
  'refugiar',
  'regalia',
  'regime',
  'regra',
  'reinado',
  'reitor',
  'rejeitar',
  'relativo',
  'remador',
  'remendo',
  'remorso',
  'renovado',
  'reparo',
  'repelir',
  'repleto',
  'repolho',
  'represa',
  'repudiar',
  'requerer',
  'resenha',
  'resfriar',
  'resgatar',
  'residir',
  'resolver',
  'respeito',
  'ressaca',
  'restante',
  'resumir',
  'retalho',
  'reter',
  'retirar',
  'retomada',
  'retratar',
  'revelar',
  'revisor',
  'revolta',
  'riacho',
  'rica',
  'rigidez',
  'rigoroso',
  'rimar',
  'ringue',
  'risada',
  'risco',
  'risonho',
  'robalo',
  'rochedo',
  'rodada',
  'rodeio',
  'rodovia',
  'roedor',
  'roleta',
  'romano',
  'roncar',
  'rosado',
  'roseira',
  'rosto',
  'rota',
  'roteiro',
  'rotina',
  'rotular',
  'rouco',
  'roupa',
  'roxo',
  'rubro',
  'rugido',
  'rugoso',
  'ruivo',
  'rumo',
  'rupestre',
  'russo',
  'sabor',
  'saciar',
  'sacola',
  'sacudir',
  'sadio',
  'safira',
  'saga',
  'sagrada',
  'saibro',
  'salada',
  'saleiro',
  'salgado',
  'saliva',
  'salpicar',
  'salsicha',
  'saltar',
  'salvador',
  'sambar',
  'samurai',
  'sanar',
  'sanfona',
  'sangue',
  'sanidade',
  'sapato',
  'sarda',
  'sargento',
  'sarjeta',
  'saturar',
  'saudade',
  'saxofone',
  'sazonal',
  'secar',
  'secular',
  'seda',
  'sedento',
  'sediado',
  'sedoso',
  'sedutor',
  'segmento',
  'segredo',
  'segundo',
  'seiva',
  'seleto',
  'selvagem',
  'semanal',
  'semente',
  'senador',
  'senhor',
  'sensual',
  'sentado',
  'separado',
  'sereia',
  'seringa',
  'serra',
  'servo',
  'setembro',
  'setor',
  'sigilo',
  'silhueta',
  'silicone',
  'simetria',
  'simpatia',
  'simular',
  'sinal',
  'sincero',
  'singular',
  'sinopse',
  'sintonia',
  'sirene',
  'siri',
  'situado',
  'soberano',
  'sobra',
  'socorro',
  'sogro',
  'soja',
  'solda',
  'soletrar',
  'solteiro',
  'sombrio',
  'sonata',
  'sondar',
  'sonegar',
  'sonhador',
  'sono',
  'soprano',
  'soquete',
  'sorrir',
  'sorteio',
  'sossego',
  'sotaque',
  'soterrar',
  'sovado',
  'sozinho',
  'suavizar',
  'subida',
  'submerso',
  'subsolo',
  'subtrair',
  'sucata',
  'sucesso',
  'suco',
  'sudeste',
  'sufixo',
  'sugador',
  'sugerir',
  'sujeito',
  'sulfato',
  'sumir',
  'suor',
  'superior',
  'suplicar',
  'suposto',
  'suprimir',
  'surdina',
  'surfista',
  'surpresa',
  'surreal',
  'surtir',
  'suspiro',
  'sustento',
  'tabela',
  'tablete',
  'tabuada',
  'tacho',
  'tagarela',
  'talher',
  'talo',
  'talvez',
  'tamanho',
  'tamborim',
  'tampa',
  'tangente',
  'tanto',
  'tapar',
  'tapioca',
  'tardio',
  'tarefa',
  'tarja',
  'tarraxa',
  'tatuagem',
  'taurino',
  'taxativo',
  'taxista',
  'teatral',
  'tecer',
  'tecido',
  'teclado',
  'tedioso',
  'teia',
  'teimar',
  'telefone',
  'telhado',
  'tempero',
  'tenente',
  'tensor',
  'tentar',
  'termal',
  'terno',
  'terreno',
  'tese',
  'tesoura',
  'testado',
  'teto',
  'textura',
  'texugo',
  'tiara',
  'tigela',
  'tijolo',
  'timbrar',
  'timidez',
  'tingido',
  'tinteiro',
  'tiragem',
  'titular',
  'toalha',
  'tocha',
  'tolerar',
  'tolice',
  'tomada',
  'tomilho',
  'tonel',
  'tontura',
  'topete',
  'tora',
  'torcido',
  'torneio',
  'torque',
  'torrada',
  'torto',
  'tostar',
  'touca',
  'toupeira',
  'toxina',
  'trabalho',
  'tracejar',
  'tradutor',
  'trafegar',
  'trajeto',
  'trama',
  'trancar',
  'trapo',
  'traseiro',
  'tratador',
  'travar',
  'treino',
  'tremer',
  'trepidar',
  'trevo',
  'triagem',
  'tribo',
  'triciclo',
  'tridente',
  'trilogia',
  'trindade',
  'triplo',
  'triturar',
  'triunfal',
  'trocar',
  'trombeta',
  'trova',
  'trunfo',
  'truque',
  'tubular',
  'tucano',
  'tudo',
  'tulipa',
  'tupi',
  'turbo',
  'turma',
  'turquesa',
  'tutelar',
  'tutorial',
  'uivar',
  'umbigo',
  'unha',
  'unidade',
  'uniforme',
  'urologia',
  'urso',
  'urtiga',
  'urubu',
  'usado',
  'usina',
  'usufruir',
  'vacina',
  'vadiar',
  'vagaroso',
  'vaidoso',
  'vala',
  'valente',
  'validade',
  'valores',
  'vantagem',
  'vaqueiro',
  'varanda',
  'vareta',
  'varrer',
  'vascular',
  'vasilha',
  'vassoura',
  'vazar',
  'vazio',
  'veado',
  'vedar',
  'vegetar',
  'veicular',
  'veleiro',
  'velhice',
  'veludo',
  'vencedor',
  'vendaval',
  'venerar',
  'ventre',
  'verbal',
  'verdade',
  'vereador',
  'vergonha',
  'vermelho',
  'verniz',
  'versar',
  'vertente',
  'vespa',
  'vestido',
  'vetorial',
  'viaduto',
  'viagem',
  'viajar',
  'viatura',
  'vibrador',
  'videira',
  'vidraria',
  'viela',
  'viga',
  'vigente',
  'vigiar',
  'vigorar',
  'vilarejo',
  'vinco',
  'vinheta',
  'vinil',
  'violeta',
  'virada',
  'virtude',
  'visitar',
  'visto',
  'vitral',
  'viveiro',
  'vizinho',
  'voador',
  'voar',
  'vogal',
  'volante',
  'voleibol',
  'voltagem',
  'volumoso',
  'vontade',
  'vulto',
  'vuvuzela',
  'xadrez',
  'xarope',
  'xeque',
  'xeretar',
  'xerife',
  'xingar',
  'zangado',
  'zarpar',
  'zebu',
  'zelador',
  'zombar',
  'zoologia',
  'zumbido',
  'abandon',
  'ability',
  'able',
  'about',
  'above',
  'absent',
  'absorb',
  'abstract',
  'absurd',
  'abuse',
  'access',
  'accident',
  'account',
  'accuse',
  'achieve',
  'acid',
  'acoustic',
  'acquire',
  'across',
  'act',
  'action',
  'actor',
  'actress',
  'actual',
  'adapt',
  'add',
  'addict',
  'address',
  'adjust',
  'admit',
  'adult',
  'advance',
  'advice',
  'aerobic',
  'affair',
  'afford',
  'afraid',
  'again',
  'age',
  'agent',
  'agree',
  'ahead',
  'aim',
  'air',
  'airport',
  'aisle',
  'alarm',
  'album',
  'alcohol',
  'alert',
  'alien',
  'all',
  'alley',
  'allow',
  'almost',
  'alone',
  'alpha',
  'already',
  'also',
  'alter',
  'always',
  'amateur',
  'amazing',
  'among',
  'amount',
  'amused',
  'analyst',
  'anchor',
  'ancient',
  'anger',
  'angle',
  'angry',
  'animal',
  'ankle',
  'announce',
  'annual',
  'another',
  'answer',
  'antenna',
  'antique',
  'anxiety',
  'any',
  'apart',
  'apology',
  'appear',
  'apple',
  'approve',
  'april',
  'arch',
  'arctic',
  'area',
  'arena',
  'argue',
  'arm',
  'armed',
  'armor',
  'army',
  'around',
  'arrange',
  'arrest',
  'arrive',
  'arrow',
  'art',
  'artefact',
  'artist',
  'artwork',
  'ask',
  'aspect',
  'assault',
  'asset',
  'assist',
  'assume',
  'asthma',
  'athlete',
  'atom',
  'attack',
  'attend',
  'attitude',
  'attract',
  'auction',
  'audit',
  'august',
  'aunt',
  'author',
  'auto',
  'autumn',
  'average',
  'avocado',
  'avoid',
  'awake',
  'aware',
  'away',
  'awesome',
  'awful',
  'awkward',
  'axis',
  'baby',
  'bachelor',
  'bacon',
  'badge',
  'bag',
  'balance',
  'balcony',
  'ball',
  'bamboo',
  'banana',
  'banner',
  'bar',
  'barely',
  'bargain',
  'barrel',
  'base',
  'basic',
  'basket',
  'battle',
  'beach',
  'bean',
  'beauty',
  'because',
  'become',
  'beef',
  'before',
  'begin',
  'behave',
  'behind',
  'believe',
  'below',
  'belt',
  'bench',
  'benefit',
  'best',
  'betray',
  'better',
  'between',
  'beyond',
  'bicycle',
  'bid',
  'bike',
  'bind',
  'biology',
  'bird',
  'birth',
  'bitter',
  'black',
  'blade',
  'blame',
  'blanket',
  'blast',
  'bleak',
  'bless',
  'blind',
  'blood',
  'blossom',
  'blouse',
  'blue',
  'blur',
  'blush',
  'board',
  'boat',
  'body',
  'boil',
  'bomb',
  'bone',
  'bonus',
  'book',
  'boost',
  'border',
  'boring',
  'borrow',
  'boss',
  'bottom',
  'bounce',
  'box',
  'boy',
  'bracket',
  'brain',
  'brand',
  'brass',
  'brave',
  'bread',
  'breeze',
  'brick',
  'bridge',
  'brief',
  'bright',
  'bring',
  'brisk',
  'broccoli',
  'broken',
  'bronze',
  'broom',
  'brother',
  'brown',
  'brush',
  'bubble',
  'buddy',
  'budget',
  'buffalo',
  'build',
  'bulb',
  'bulk',
  'bullet',
  'bundle',
  'bunker',
  'burden',
  'burger',
  'burst',
  'bus',
  'business',
  'busy',
  'butter',
  'buyer',
  'buzz',
  'cabbage',
  'cabin',
  'cable',
  'cactus',
  'cage',
  'cake',
  'call',
  'calm',
  'camera',
  'camp',
  'can',
  'canal',
  'cancel',
  'candy',
  'cannon',
  'canoe',
  'canvas',
  'canyon',
  'capable',
  'capital',
  'captain',
  'car',
  'carbon',
  'card',
  'cargo',
  'carpet',
  'carry',
  'cart',
  'case',
  'cash',
  'casino',
  'castle',
  'casual',
  'cat',
  'catalog',
  'catch',
  'category',
  'cattle',
  'caught',
  'cause',
  'caution',
  'cave',
  'ceiling',
  'celery',
  'cement',
  'census',
  'century',
  'cereal',
  'certain',
  'chair',
  'chalk',
  'champion',
  'change',
  'chaos',
  'chapter',
  'charge',
  'chase',
  'chat',
  'cheap',
  'check',
  'cheese',
  'chef',
  'cherry',
  'chest',
  'chicken',
  'chief',
  'child',
  'chimney',
  'choice',
  'choose',
  'chronic',
  'chuckle',
  'chunk',
  'churn',
  'cigar',
  'cinnamon',
  'circle',
  'citizen',
  'city',
  'civil',
  'claim',
  'clap',
  'clarify',
  'claw',
  'clay',
  'clean',
  'clerk',
  'clever',
  'click',
  'client',
  'cliff',
  'climb',
  'clinic',
  'clip',
  'clock',
  'clog',
  'close',
  'cloth',
  'cloud',
  'clown',
  'club',
  'clump',
  'cluster',
  'clutch',
  'coach',
  'coast',
  'coconut',
  'code',
  'coffee',
  'coil',
  'coin',
  'collect',
  'color',
  'column',
  'combine',
  'come',
  'comfort',
  'comic',
  'common',
  'company',
  'concert',
  'conduct',
  'confirm',
  'congress',
  'connect',
  'consider',
  'control',
  'convince',
  'cook',
  'cool',
  'copper',
  'copy',
  'coral',
  'core',
  'corn',
  'correct',
  'cost',
  'cotton',
  'couch',
  'country',
  'couple',
  'course',
  'cousin',
  'cover',
  'coyote',
  'crack',
  'cradle',
  'craft',
  'cram',
  'crane',
  'crash',
  'crater',
  'crawl',
  'crazy',
  'cream',
  'credit',
  'creek',
  'crew',
  'cricket',
  'crime',
  'crisp',
  'critic',
  'crop',
  'cross',
  'crouch',
  'crowd',
  'crucial',
  'cruel',
  'cruise',
  'crumble',
  'crunch',
  'crush',
  'cry',
  'crystal',
  'cube',
  'culture',
  'cup',
  'cupboard',
  'curious',
  'current',
  'curtain',
  'curve',
  'cushion',
  'custom',
  'cute',
  'cycle',
  'dad',
  'damage',
  'damp',
  'dance',
  'danger',
  'daring',
  'dash',
  'daughter',
  'dawn',
  'day',
  'deal',
  'debate',
  'debris',
  'decade',
  'december',
  'decide',
  'decline',
  'decorate',
  'decrease',
  'deer',
  'defense',
  'define',
  'defy',
  'degree',
  'delay',
  'deliver',
  'demand',
  'demise',
  'denial',
  'dentist',
  'deny',
  'depart',
  'depend',
  'deposit',
  'depth',
  'deputy',
  'derive',
  'describe',
  'desert',
  'design',
  'desk',
  'despair',
  'destroy',
  'detail',
  'detect',
  'develop',
  'device',
  'devote',
  'diagram',
  'dial',
  'diamond',
  'diary',
  'dice',
  'diesel',
  'diet',
  'differ',
  'digital',
  'dignity',
  'dilemma',
  'dinner',
  'dinosaur',
  'direct',
  'dirt',
  'disagree',
  'discover',
  'disease',
  'dish',
  'dismiss',
  'disorder',
  'display',
  'distance',
  'divert',
  'divide',
  'divorce',
  'dizzy',
  'doctor',
  'document',
  'dog',
  'doll',
  'dolphin',
  'domain',
  'donate',
  'donkey',
  'donor',
  'door',
  'dose',
  'double',
  'dove',
  'draft',
  'dragon',
  'drama',
  'drastic',
  'draw',
  'dream',
  'dress',
  'drift',
  'drill',
  'drink',
  'drip',
  'drive',
  'drop',
  'drum',
  'dry',
  'duck',
  'dumb',
  'dune',
  'during',
  'dust',
  'dutch',
  'duty',
  'dwarf',
  'dynamic',
  'eager',
  'eagle',
  'early',
  'earn',
  'earth',
  'easily',
  'east',
  'easy',
  'echo',
  'ecology',
  'economy',
  'edge',
  'edit',
  'educate',
  'effort',
  'egg',
  'eight',
  'either',
  'elbow',
  'elder',
  'electric',
  'elegant',
  'element',
  'elephant',
  'elevator',
  'elite',
  'else',
  'embark',
  'embody',
  'embrace',
  'emerge',
  'emotion',
  'employ',
  'empower',
  'empty',
  'enable',
  'enact',
  'end',
  'endless',
  'endorse',
  'enemy',
  'energy',
  'enforce',
  'engage',
  'engine',
  'enhance',
  'enjoy',
  'enlist',
  'enough',
  'enrich',
  'enroll',
  'ensure',
  'enter',
  'entire',
  'entry',
  'envelope',
  'episode',
  'equal',
  'equip',
  'era',
  'erase',
  'erode',
  'erosion',
  'error',
  'erupt',
  'escape',
  'essay',
  'essence',
  'estate',
  'eternal',
  'ethics',
  'evidence',
  'evil',
  'evoke',
  'evolve',
  'exact',
  'example',
  'excess',
  'exchange',
  'excite',
  'exclude',
  'excuse',
  'execute',
  'exercise',
  'exhaust',
  'exhibit',
  'exile',
  'exist',
  'exit',
  'exotic',
  'expand',
  'expect',
  'expire',
  'explain',
  'expose',
  'express',
  'extend',
  'extra',
  'eye',
  'eyebrow',
  'fabric',
  'face',
  'faculty',
  'fade',
  'faint',
  'faith',
  'fall',
  'false',
  'fame',
  'family',
  'famous',
  'fan',
  'fancy',
  'fantasy',
  'farm',
  'fashion',
  'fat',
  'fatal',
  'father',
  'fatigue',
  'fault',
  'favorite',
  'feature',
  'february',
  'federal',
  'fee',
  'feed',
  'feel',
  'female',
  'fence',
  'festival',
  'fetch',
  'fever',
  'few',
  'fiber',
  'fiction',
  'field',
  'figure',
  'file',
  'film',
  'filter',
  'final',
  'find',
  'fine',
  'finger',
  'finish',
  'fire',
  'firm',
  'first',
  'fiscal',
  'fish',
  'fit',
  'fitness',
  'fix',
  'flag',
  'flame',
  'flash',
  'flat',
  'flavor',
  'flee',
  'flight',
  'flip',
  'float',
  'flock',
  'floor',
  'flower',
  'fluid',
  'flush',
  'fly',
  'foam',
  'focus',
  'fog',
  'foil',
  'fold',
  'follow',
  'food',
  'foot',
  'force',
  'forest',
  'forget',
  'fork',
  'fortune',
  'forum',
  'forward',
  'fossil',
  'foster',
  'found',
  'fox',
  'fragile',
  'frame',
  'frequent',
  'fresh',
  'friend',
  'fringe',
  'frog',
  'front',
  'frost',
  'frown',
  'frozen',
  'fruit',
  'fuel',
  'fun',
  'funny',
  'furnace',
  'fury',
  'future',
  'gadget',
  'gain',
  'galaxy',
  'gallery',
  'game',
  'gap',
  'garage',
  'garbage',
  'garden',
  'garlic',
  'garment',
  'gas',
  'gasp',
  'gate',
  'gather',
  'gauge',
  'gaze',
  'general',
  'genius',
  'genre',
  'gentle',
  'genuine',
  'gesture',
  'ghost',
  'giant',
  'gift',
  'giggle',
  'ginger',
  'giraffe',
  'girl',
  'give',
  'glad',
  'glance',
  'glare',
  'glass',
  'glide',
  'glimpse',
  'globe',
  'gloom',
  'glory',
  'glove',
  'glow',
  'glue',
  'goat',
  'goddess',
  'gold',
  'good',
  'goose',
  'gorilla',
  'gospel',
  'gossip',
  'govern',
  'gown',
  'grab',
  'grace',
  'grain',
  'grant',
  'grape',
  'grass',
  'gravity',
  'great',
  'green',
  'grid',
  'grief',
  'grit',
  'grocery',
  'group',
  'grow',
  'grunt',
  'guard',
  'guess',
  'guide',
  'guilt',
  'guitar',
  'gun',
  'gym',
  'habit',
  'hair',
  'half',
  'hammer',
  'hamster',
  'hand',
  'happy',
  'harbor',
  'hard',
  'harsh',
  'harvest',
  'hat',
  'have',
  'hawk',
  'hazard',
  'head',
  'health',
  'heart',
  'heavy',
  'hedgehog',
  'height',
  'hello',
  'helmet',
  'help',
  'hen',
  'hero',
  'hidden',
  'high',
  'hill',
  'hint',
  'hip',
  'hire',
  'history',
  'hobby',
  'hockey',
  'hold',
  'hole',
  'holiday',
  'hollow',
  'home',
  'honey',
  'hood',
  'hope',
  'horn',
  'horror',
  'horse',
  'hospital',
  'host',
  'hotel',
  'hour',
  'hover',
  'hub',
  'huge',
  'human',
  'humble',
  'humor',
  'hundred',
  'hungry',
  'hunt',
  'hurdle',
  'hurry',
  'hurt',
  'husband',
  'hybrid',
  'ice',
  'icon',
  'idea',
  'identify',
  'idle',
  'ignore',
  'ill',
  'illegal',
  'illness',
  'image',
  'imitate',
  'immense',
  'immune',
  'impact',
  'impose',
  'improve',
  'impulse',
  'inch',
  'include',
  'income',
  'increase',
  'index',
  'indicate',
  'indoor',
  'industry',
  'infant',
  'inflict',
  'inform',
  'inhale',
  'inherit',
  'initial',
  'inject',
  'injury',
  'inmate',
  'inner',
  'innocent',
  'input',
  'inquiry',
  'insane',
  'insect',
  'inside',
  'inspire',
  'install',
  'intact',
  'interest',
  'into',
  'invest',
  'invite',
  'involve',
  'iron',
  'island',
  'isolate',
  'issue',
  'item',
  'ivory',
  'jacket',
  'jaguar',
  'jar',
  'jazz',
  'jealous',
  'jeans',
  'jelly',
  'jewel',
  'job',
  'join',
  'joke',
  'journey',
  'joy',
  'judge',
  'juice',
  'jump',
  'jungle',
  'junior',
  'junk',
  'just',
  'kangaroo',
  'keen',
  'keep',
  'ketchup',
  'key',
  'kick',
  'kid',
  'kidney',
  'kind',
  'kingdom',
  'kiss',
  'kit',
  'kitchen',
  'kite',
  'kitten',
  'kiwi',
  'knee',
  'knife',
  'knock',
  'know',
  'lab',
  'label',
  'labor',
  'ladder',
  'lady',
  'lake',
  'lamp',
  'language',
  'laptop',
  'large',
  'later',
  'latin',
  'laugh',
  'laundry',
  'lava',
  'law',
  'lawn',
  'lawsuit',
  'layer',
  'lazy',
  'leader',
  'leaf',
  'learn',
  'leave',
  'lecture',
  'left',
  'leg',
  'legal',
  'legend',
  'leisure',
  'lemon',
  'lend',
  'length',
  'lens',
  'leopard',
  'lesson',
  'letter',
  'level',
  'liar',
  'liberty',
  'library',
  'license',
  'life',
  'lift',
  'light',
  'like',
  'limb',
  'limit',
  'link',
  'lion',
  'liquid',
  'list',
  'little',
  'live',
  'lizard',
  'load',
  'loan',
  'lobster',
  'local',
  'lock',
  'logic',
  'lonely',
  'long',
  'loop',
  'lottery',
  'loud',
  'lounge',
  'love',
  'loyal',
  'lucky',
  'luggage',
  'lumber',
  'lunar',
  'lunch',
  'luxury',
  'lyrics',
  'machine',
  'mad',
  'magic',
  'magnet',
  'maid',
  'mail',
  'main',
  'major',
  'make',
  'mammal',
  'man',
  'manage',
  'mandate',
  'mango',
  'mansion',
  'manual',
  'maple',
  'marble',
  'march',
  'margin',
  'marine',
  'market',
  'marriage',
  'mask',
  'mass',
  'master',
  'match',
  'material',
  'math',
  'matrix',
  'matter',
  'maximum',
  'maze',
  'meadow',
  'mean',
  'measure',
  'meat',
  'mechanic',
  'medal',
  'media',
  'melody',
  'melt',
  'member',
  'memory',
  'mention',
  'menu',
  'mercy',
  'merge',
  'merit',
  'merry',
  'mesh',
  'message',
  'metal',
  'method',
  'middle',
  'midnight',
  'milk',
  'million',
  'mimic',
  'mind',
  'minimum',
  'minor',
  'minute',
  'miracle',
  'mirror',
  'misery',
  'miss',
  'mistake',
  'mix',
  'mixed',
  'mixture',
  'mobile',
  'model',
  'modify',
  'mom',
  'moment',
  'monitor',
  'monkey',
  'monster',
  'month',
  'moon',
  'moral',
  'more',
  'morning',
  'mosquito',
  'mother',
  'motion',
  'motor',
  'mountain',
  'mouse',
  'move',
  'movie',
  'much',
  'muffin',
  'mule',
  'multiply',
  'muscle',
  'museum',
  'mushroom',
  'music',
  'must',
  'mutual',
  'myself',
  'mystery',
  'myth',
  'naive',
  'name',
  'napkin',
  'narrow',
  'nasty',
  'nation',
  'nature',
  'near',
  'neck',
  'need',
  'negative',
  'neglect',
  'neither',
  'nephew',
  'nerve',
  'nest',
  'net',
  'network',
  'neutral',
  'never',
  'news',
  'next',
  'nice',
  'night',
  'noble',
  'noise',
  'nominee',
  'noodle',
  'normal',
  'north',
  'nose',
  'notable',
  'note',
  'nothing',
  'notice',
  'novel',
  'now',
  'nuclear',
  'number',
  'nurse',
  'nut',
  'oak',
  'obey',
  'object',
  'oblige',
  'obscure',
  'observe',
  'obtain',
  'obvious',
  'occur',
  'ocean',
  'october',
  'odor',
  'off',
  'offer',
  'office',
  'often',
  'oil',
  'okay',
  'old',
  'olive',
  'olympic',
  'omit',
  'once',
  'one',
  'onion',
  'online',
  'only',
  'open',
  'opera',
  'opinion',
  'oppose',
  'option',
  'orange',
  'orbit',
  'orchard',
  'order',
  'ordinary',
  'organ',
  'orient',
  'original',
  'orphan',
  'ostrich',
  'other',
  'outdoor',
  'outer',
  'output',
  'outside',
  'oval',
  'oven',
  'over',
  'own',
  'owner',
  'oxygen',
  'oyster',
  'ozone',
  'pact',
  'paddle',
  'page',
  'pair',
  'palace',
  'palm',
  'panda',
  'panel',
  'panic',
  'panther',
  'paper',
  'parade',
  'parent',
  'park',
  'parrot',
  'party',
  'pass',
  'patch',
  'path',
  'patient',
  'patrol',
  'pattern',
  'pause',
  'pave',
  'payment',
  'peace',
  'peanut',
  'pear',
  'peasant',
  'pelican',
  'pen',
  'penalty',
  'pencil',
  'people',
  'pepper',
  'perfect',
  'permit',
  'person',
  'pet',
  'phone',
  'photo',
  'phrase',
  'physical',
  'piano',
  'picnic',
  'picture',
  'piece',
  'pig',
  'pigeon',
  'pill',
  'pilot',
  'pink',
  'pioneer',
  'pipe',
  'pistol',
  'pitch',
  'pizza',
  'place',
  'planet',
  'plastic',
  'plate',
  'play',
  'please',
  'pledge',
  'pluck',
  'plug',
  'plunge',
  'poem',
  'poet',
  'point',
  'polar',
  'pole',
  'police',
  'pond',
  'pony',
  'pool',
  'popular',
  'portion',
  'position',
  'possible',
  'post',
  'potato',
  'pottery',
  'poverty',
  'powder',
  'power',
  'practice',
  'praise',
  'predict',
  'prefer',
  'prepare',
  'present',
  'pretty',
  'prevent',
  'price',
  'pride',
  'primary',
  'print',
  'priority',
  'prison',
  'private',
  'prize',
  'problem',
  'process',
  'produce',
  'profit',
  'program',
  'project',
  'promote',
  'proof',
  'property',
  'prosper',
  'protect',
  'proud',
  'provide',
  'public',
  'pudding',
  'pull',
  'pulp',
  'pulse',
  'pumpkin',
  'punch',
  'pupil',
  'puppy',
  'purchase',
  'purity',
  'purpose',
  'purse',
  'push',
  'put',
  'puzzle',
  'pyramid',
  'quality',
  'quantum',
  'quarter',
  'question',
  'quick',
  'quit',
  'quiz',
  'quote',
  'rabbit',
  'raccoon',
  'race',
  'rack',
  'radar',
  'radio',
  'rail',
  'rain',
  'raise',
  'rally',
  'ramp',
  'ranch',
  'random',
  'range',
  'rapid',
  'rare',
  'rate',
  'rather',
  'raven',
  'raw',
  'razor',
  'ready',
  'real',
  'reason',
  'rebel',
  'rebuild',
  'recall',
  'receive',
  'recipe',
  'record',
  'recycle',
  'reduce',
  'reflect',
  'reform',
  'refuse',
  'region',
  'regret',
  'regular',
  'reject',
  'relax',
  'release',
  'relief',
  'rely',
  'remain',
  'remember',
  'remind',
  'remove',
  'render',
  'renew',
  'rent',
  'reopen',
  'repair',
  'repeat',
  'replace',
  'report',
  'require',
  'rescue',
  'resemble',
  'resist',
  'resource',
  'response',
  'result',
  'retire',
  'retreat',
  'return',
  'reunion',
  'reveal',
  'review',
  'reward',
  'rhythm',
  'rib',
  'ribbon',
  'rice',
  'rich',
  'ride',
  'ridge',
  'rifle',
  'right',
  'rigid',
  'ring',
  'riot',
  'ripple',
  'risk',
  'ritual',
  'rival',
  'river',
  'road',
  'roast',
  'robot',
  'robust',
  'rocket',
  'romance',
  'roof',
  'rookie',
  'room',
  'rose',
  'rotate',
  'rough',
  'round',
  'route',
  'royal',
  'rubber',
  'rude',
  'rug',
  'rule',
  'run',
  'runway',
  'rural',
  'sad',
  'saddle',
  'sadness',
  'safe',
  'sail',
  'salad',
  'salmon',
  'salon',
  'salt',
  'salute',
  'same',
  'sample',
  'sand',
  'satisfy',
  'satoshi',
  'sauce',
  'sausage',
  'save',
  'say',
  'scale',
  'scan',
  'scare',
  'scatter',
  'scene',
  'scheme',
  'school',
  'science',
  'scissors',
  'scorpion',
  'scout',
  'scrap',
  'screen',
  'script',
  'scrub',
  'sea',
  'search',
  'season',
  'seat',
  'second',
  'secret',
  'section',
  'security',
  'seed',
  'seek',
  'segment',
  'select',
  'sell',
  'seminar',
  'senior',
  'sense',
  'sentence',
  'series',
  'service',
  'session',
  'settle',
  'setup',
  'seven',
  'shadow',
  'shaft',
  'shallow',
  'share',
  'shed',
  'shell',
  'sheriff',
  'shield',
  'shift',
  'shine',
  'ship',
  'shiver',
  'shock',
  'shoe',
  'shoot',
  'shop',
  'short',
  'shoulder',
  'shove',
  'shrimp',
  'shrug',
  'shuffle',
  'shy',
  'sibling',
  'sick',
  'side',
  'siege',
  'sight',
  'sign',
  'silent',
  'silk',
  'silly',
  'silver',
  'similar',
  'simple',
  'since',
  'sing',
  'siren',
  'sister',
  'situate',
  'six',
  'size',
  'skate',
  'sketch',
  'ski',
  'skill',
  'skin',
  'skirt',
  'skull',
  'slab',
  'slam',
  'sleep',
  'slender',
  'slice',
  'slide',
  'slight',
  'slim',
  'slogan',
  'slot',
  'slow',
  'slush',
  'small',
  'smart',
  'smile',
  'smoke',
  'smooth',
  'snack',
  'snake',
  'snap',
  'sniff',
  'snow',
  'soap',
  'soccer',
  'social',
  'sock',
  'soda',
  'soft',
  'solar',
  'soldier',
  'solid',
  'solution',
  'solve',
  'someone',
  'song',
  'soon',
  'sorry',
  'sort',
  'soul',
  'sound',
  'soup',
  'source',
  'south',
  'space',
  'spare',
  'spatial',
  'spawn',
  'speak',
  'special',
  'speed',
  'spell',
  'spend',
  'sphere',
  'spice',
  'spider',
  'spike',
  'spin',
  'spirit',
  'split',
  'spoil',
  'sponsor',
  'spoon',
  'sport',
  'spot',
  'spray',
  'spread',
  'spring',
  'spy',
  'square',
  'squeeze',
  'squirrel',
  'stable',
  'stadium',
  'staff',
  'stage',
  'stairs',
  'stamp',
  'stand',
  'start',
  'state',
  'stay',
  'steak',
  'steel',
  'stem',
  'step',
  'stereo',
  'stick',
  'still',
  'sting',
  'stock',
  'stomach',
  'stone',
  'stool',
  'story',
  'stove',
  'strategy',
  'street',
  'strike',
  'strong',
  'struggle',
  'student',
  'stuff',
  'stumble',
  'style',
  'subject',
  'submit',
  'subway',
  'success',
  'such',
  'sudden',
  'suffer',
  'sugar',
  'suggest',
  'suit',
  'summer',
  'sun',
  'sunny',
  'sunset',
  'super',
  'supply',
  'supreme',
  'sure',
  'surface',
  'surge',
  'surprise',
  'surround',
  'survey',
  'suspect',
  'sustain',
  'swallow',
  'swamp',
  'swap',
  'swarm',
  'swear',
  'sweet',
  'swift',
  'swim',
  'swing',
  'switch',
  'sword',
  'symbol',
  'symptom',
  'syrup',
  'system',
  'table',
  'tackle',
  'tag',
  'tail',
  'talent',
  'talk',
  'tank',
  'tape',
  'target',
  'task',
  'taste',
  'tattoo',
  'taxi',
  'teach',
  'team',
  'tell',
  'ten',
  'tenant',
  'tennis',
  'tent',
  'term',
  'test',
  'text',
  'thank',
  'that',
  'theme',
  'then',
  'theory',
  'there',
  'they',
  'thing',
  'this',
  'thought',
  'three',
  'thrive',
  'throw',
  'thumb',
  'thunder',
  'ticket',
  'tide',
  'tiger',
  'tilt',
  'timber',
  'time',
  'tiny',
  'tip',
  'tired',
  'tissue',
  'title',
  'toast',
  'tobacco',
  'today',
  'toddler',
  'toe',
  'together',
  'toilet',
  'token',
  'tomato',
  'tomorrow',
  'tone',
  'tongue',
  'tonight',
  'tool',
  'tooth',
  'top',
  'topic',
  'topple',
  'torch',
  'tornado',
  'tortoise',
  'toss',
  'total',
  'tourist',
  'toward',
  'tower',
  'town',
  'toy',
  'track',
  'trade',
  'traffic',
  'tragic',
  'train',
  'transfer',
  'trap',
  'trash',
  'travel',
  'tray',
  'treat',
  'tree',
  'trend',
  'trial',
  'tribe',
  'trick',
  'trigger',
  'trim',
  'trip',
  'trophy',
  'trouble',
  'truck',
  'true',
  'truly',
  'trumpet',
  'trust',
  'truth',
  'try',
  'tube',
  'tuition',
  'tumble',
  'tuna',
  'tunnel',
  'turkey',
  'turn',
  'turtle',
  'twelve',
  'twenty',
  'twice',
  'twin',
  'twist',
  'two',
  'type',
  'typical',
  'ugly',
  'umbrella',
  'unable',
  'unaware',
  'uncle',
  'uncover',
  'under',
  'undo',
  'unfair',
  'unfold',
  'unhappy',
  'uniform',
  'unique',
  'unit',
  'universe',
  'unknown',
  'unlock',
  'until',
  'unusual',
  'unveil',
  'update',
  'upgrade',
  'uphold',
  'upon',
  'upper',
  'upset',
  'urban',
  'urge',
  'usage',
  'use',
  'used',
  'useful',
  'useless',
  'usual',
  'utility',
  'vacant',
  'vacuum',
  'vague',
  'valid',
  'valley',
  'valve',
  'van',
  'vanish',
  'vapor',
  'various',
  'vast',
  'vault',
  'vehicle',
  'velvet',
  'vendor',
  'venture',
  'venue',
  'verb',
  'verify',
  'version',
  'very',
  'vessel',
  'veteran',
  'viable',
  'vibrant',
  'vicious',
  'victory',
  'video',
  'view',
  'village',
  'vintage',
  'violin',
  'virtual',
  'virus',
  'visa',
  'visit',
  'visual',
  'vital',
  'vivid',
  'vocal',
  'voice',
  'void',
  'volcano',
  'volume',
  'vote',
  'voyage',
  'wage',
  'wagon',
  'wait',
  'walk',
  'wall',
  'walnut',
  'want',
  'warfare',
  'warm',
  'warrior',
  'wash',
  'wasp',
  'waste',
  'water',
  'wave',
  'way',
  'wealth',
  'weapon',
  'wear',
  'weasel',
  'weather',
  'web',
  'wedding',
  'weekend',
  'weird',
  'welcome',
  'west',
  'wet',
  'whale',
  'what',
  'wheat',
  'wheel',
  'when',
  'where',
  'whip',
  'whisper',
  'wide',
  'width',
  'wife',
  'wild',
  'will',
  'win',
  'window',
  'wine',
  'wing',
  'wink',
  'winner',
  'winter',
  'wire',
  'wisdom',
  'wise',
  'wish',
  'witness',
  'wolf',
  'woman',
  'wonder',
  'wood',
  'wool',
  'word',
  'work',
  'world',
  'worry',
  'worth',
  'wrap',
  'wreck',
  'wrestle',
  'wrist',
  'write',
  'wrong',
  'yard',
  'year',
  'yellow',
  'you',
  'young',
  'youth',
  'zebra',
  'zero',
  'zone',
  'zoo',
]
